var firebaseConfig = {
  apiKey: "AIzaSyC4RE9yxQNmXro13ev7AA-a6o9yczOXzTU",
  authDomain: "reasons-c1caf.firebaseapp.com",
  projectId: "reasons-c1caf",
  storageBucket: "reasons-c1caf.appspot.com",
  messagingSenderId: "791509972546",
  appId: "1:791509972546:web:fd9a1a0a7e3f21c2dc9fdb"
  };

  export default firebaseConfig;
